import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import {
  useDisableScreenShareForNonModerator,
  useEnableScreenShareForNonModerator,
} from "../api/toggle-screen-share";

export function ParticipantScreenSharingToggle() {
  const isParticipantScreenSharing = useVidyoStore(
    (state) => state.screenShare.isParticipantScreenSharing,
  );
  const sessionId = useVidyoStore((state) => state.sessionId);

  const {
    mutateAsync: enableScreenShareForNonModerator,
    isPending: isEnablingScreenShareForNonModerator,
  } = useEnableScreenShareForNonModerator();

  const {
    mutateAsync: disableScreenShareForNonModerator,
    isPending: isDisablingScreenShareForNonModerator,
  } = useDisableScreenShareForNonModerator();

  const handleToggleScreenShare = async () => {
    if (isParticipantScreenSharing) {
      await disableScreenShareForNonModerator({ sessionId: sessionId });
    } else {
      await enableScreenShareForNonModerator({ sessionId: sessionId });
    }
  };

  const isLoading =
    isEnablingScreenShareForNonModerator ||
    isDisablingScreenShareForNonModerator;

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="screen-share"
        checked={isParticipantScreenSharing}
        onCheckedChange={handleToggleScreenShare}
        disabled={isLoading}
      />
      <Label htmlFor="screen-share">
        Allow non-moderators to share their screens
      </Label>
    </div>
  );
}
